// extracted by mini-css-extract-plugin
module.exports = {"container":"NewHome_container__6KQfx","gradient_audit_box":"NewHome_gradient_audit_box__zrUtX"};